import { Injectable } from '@angular/core';
import { Actions, Effect, createEffect, ofType } from '@ngrx/effects';
import { PermissionsActionTypes } from '../actions/app.actions';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Action, Store } from '@ngrx/store';
import { LayoutService } from 'src/app/core/services/layout.service';
import { LoadPermissionsSuccess } from '../actions/app.actions';

@Injectable()
export class AppEffects {

  constructor(private actions$: Actions, private layoutService: LayoutService,) { }

  loadPermission$: Observable<Action> = createEffect(() => this.actions$
    .pipe(
      ofType(PermissionsActionTypes.LoadPermissions),
      switchMap((action: any) => this.layoutService.getFirmFlowPermision()),
      map((data: any) => LoadPermissionsSuccess({ permission: data }))
    ));
}
